import React from "react";

function UltimateEvent() {
  return (
    <div>
      <section className="event-experience">
        <div className="container">
          <div className="event-experience-content">
            <h2 className="event-experience-title futuraPTBold">
              The Ultimate Event
              <br />
              Experience Starts Here
            </h2>

            <p className="event-experience-text">
              Spanning more than <strong>85,000 square feet</strong>, our{" "}
              <strong>two</strong> climate-controlled domes provide the perfect
              setting for year-round competition, training, and special events.
              From local league play and national tournaments to camps, showcases,
              and community gatherings, every square foot is designed to deliver an
              exceptional experience for athletes, spectators, and event organizers
              alike.
            </p>

            <a href="/BookEvent" className="btn plan-event-button">
              Plan Your Event
            </a>
          </div>
        </div>

        <div className="event-experience-image">
          <img
            src="/s3/ads-dome1.jpg"
            alt="ADS Sports Complex climate-controlled domes"
          />
        </div>
      </section>
    </div>
  );
}

export default UltimateEvent;
